export class SavePageRequestModel {
    dealID: number;
    pageNumber: number;
    statusID: number;
}


// WEBPACK FOOTER //
// ./src/app/_models/save-page-request.model.ts